enum OnHostItemChangedStatus {
    Selected = 0,
    Deselected = 1,
}

export default OnHostItemChangedStatus;
